import { render, staticRenderFns } from "./ProductMain.vue?vue&type=template&id=d24596b4&"
import script from "./ProductMain.vue?vue&type=script&lang=js&"
export * from "./ProductMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductFilterPanel: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/plp/ProductFilterPanel.vue').default,PlpAllRefinements: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/plp/PlpAllRefinements.vue').default,PlpProductHits: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/plp/PlpProductHits.vue').default})
